import {createTheme} from '@material-ui/core/styles'

export const theme = createTheme({
  palette: {
    primary: {
      light: '#A6BDD5',
      main: '#4376AB',
      dark: '#0D58A6',
      contrastText: '#ffffff',
    },
    secondary: {
      light: '#E7B0D0',
      main: '#CD4695',
      dark: '#CB0077',
      contrastText: '#ffffff',
    },
    warning: {
      light: '#FFE7C2',
      main: '#FFBC57',
      dark: '#B86E00',
      contrastText: '#ffffff',
    },
  },
  typography: {
    fontSize: 14,
  },
})
